// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Overlay takes the full viewport but lets Modal's internal
transform keep the centering */
.rs-modal-overlay {
    position: absolute;
    inset: 0;
    display: flex;
    justify-content: center;
    align-items: center;
}

/* Modal card */
.rs-modal {
    background: #ffffff;
    border-radius: 12px;
    width: 90%;
    max-width: 500px;
    max-height: 80vh;
    padding: 24px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

/* Typography */
.rs-title {
    margin: 0 0 8px 0;
    font-size: 1.4rem;
    font-weight: 600;
    color: #1b1b1b;
}

.rs-label {
    font-weight: 500;
    margin-right: 8px;
}

.rs-connector-sync-intro {
    margin: 6px 0 4px 0;
    font-size: 0.9rem;
    color: #666;
    line-height: 1.45;
}

.rs-label-new-links {
    margin-bottom: 10px;
    font-weight: 500;
    margin-right: 8px;
}

.rs-label-links-selection {
    margin-top: 10px;
    font-weight: 500;
    margin-right: 8px;
}

/* Info icon next to a label: give it breathing room from the colon and lift
   it to the text's optical centre — the shared tooltip wrapper (vertical-align:
   middle) sits a touch low beside the 500-weight labels here. */
.rs-label .info-tooltip-wrapper,
.rs-label-new-links .info-tooltip-wrapper,
.rs-label-links-selection .info-tooltip-wrapper {
    margin-left: 6px;
    position: relative;
    top: -1px;
}

.rs-section {
    margin-top: 16px;
}

.rs-radio-group {
    margin-top: 8px;
    margin-left: -11px;
}

.rs-radio-label {
    display: flex;
    align-items: center;
    margin-right: 16px;
    font-size: 0.95rem;
}

/* Switch row */
.rs-switch-row {
    display: flex;
    /* align-items: center; */
    flex-direction: column;
    margin-bottom: 10px;
}

.rs-switch-text {
    font-size: 0.95rem;
}

.rs-section-input-parent {
    display: flex;
}

/* Search */
.rs-search-wrapper {
    display: flex;
    position: relative;
    width: 100%;
}

.rs-search-input {
    width: 100%;
    padding: 7px 32px 7px 8px;
    border: 1px solid #d0d0d0;
    border-radius: 6px;
    font-size: 0.85rem;
    transition: border 0.2s;
    box-sizing: border-box;
    padding-left: 34px;
}

.new-links-text-toggle {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: -11px;
}

.rs-search-icon {
    position: absolute;
    top: 50%;
    left: 12px;
    transform: translateY(-50%);
    color: #aaa;
    font-size: 0.85rem;
}

.rs-search-input:focus {
    outline: none;
    border-color: #5616ea;
}

.rs-clear-button {
    position: absolute;
    top: 50%;
    right: 8px;
    transform: translateY(-50%);
    background: none;
    border: none;
    font-size: 1.6rem;
    color: #868686;
    cursor: pointer;
    padding: 0;
    line-height: 1;
    transition: color 0.2s ease;
}

.rs-clear-button:hover {
    color: #5616ea;
}

/* Link checklist */
.rs-link-box {
    border: 1px solid #d0d0d0;
    border-radius: 6px;
    margin-top: 10px;
    max-height: 300px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding-top: 5px;
}

.rs-checkbox-row {
    display: flex;
    align-items: center;
    font-size: 0.9rem;
}

.rs-checkbox-header {
    display: flex;
    align-items: center;
    font-size: 0.9rem;
    font-weight: 600;
    border-bottom: 1px solid rgb(222, 222, 222);
    padding-bottom: 6px;
}

.rs-no-links {
    margin-top: 16px;
    padding: 10px;
    background-color: #f9f9f9;
    border: 1px dashed #bbb;
    border-radius: 8px;
    text-align: center;
    font-size: 14px;
    color: #666;
}

.rs-warning-box {
    margin-top: 8px;
    padding: 10px 12px;
    background-color: #fff8e6;
    border: 1px solid #ffcc00;
    border-radius: 8px;
    font-size: 0.85rem;
    color: #856404;
    line-height: 1.4;
}

/* Buttons */
.rs-button-row {
    margin-top: 24px;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
}

.rs-btn {
    padding: 8px 18px;
    border: none;
    border-radius: 6px;
    font-weight: 600;
    font-size: 0.95rem;
    cursor: pointer;
    transition: background 0.2s, opacity 0.2s;
}

.rs-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

/* Secondary (cancel) */
.rs-btn--secondary {
    background: #f4f4f4;
    color: #333;
    transition: background-color 0.3s ease, transform 0.3s ease;
    border: 1px solid rgb(215, 215, 215);
}

.rs-btn--secondary:hover {
    background: #e1e1e1;
    transform: translateY(-1px);
}

/* Primary (save) */
.rs-btn--primary {
    background: #5616ea;
    color: #ffffff;
    transition: background-color 0.3s ease, transform 0.3s ease;
}

.rs-btn--primary:hover {
    background-color: #4a14d6;
    transform: translateY(-1px);
}

.row-checkbox {
    padding: 5px !important;
    padding-bottom: 2px !important;
    padding-top: 2px !important;
}

/* Rescraping Upgrade Modal Styles */
.rescraping-upgrade-modal-content {
    text-align: center !important;
    padding: 10px !important;
}

.rescraping-upgrade-modal-icon {
    width: 64px !important;
    height: 64px !important;
    margin: 0 auto 20px !important;
    background: linear-gradient(135deg, #5616ea 0%, #7c3aff 100%) !important;
    border-radius: 16px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    color: white !important;
}

.rescraping-upgrade-modal-icon svg {
    width: 32px !important;
    height: 32px !important;
}

.rescraping-upgrade-modal-title {
    font-size: 1.5rem !important;
    font-weight: 700 !important;
    color: #1a1a1a !important;
    margin: 0 0 12px 0 !important;
}

.rescraping-upgrade-modal-description {
    font-size: 1rem !important;
    color: #666 !important;
    line-height: 1.5 !important;
    margin: 0 0 28px 0 !important;
    padding: 0 10px !important;
}

.rescraping-upgrade-plan-info {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 16px !important;
    margin-bottom: 28px !important;
    flex-wrap: wrap !important;
}

.rescraping-upgrade-plan-badge {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    gap: 6px !important;
    padding: 14px 24px !important;
    border-radius: 10px !important;
    min-width: 120px !important;
}

.rescraping-upgrade-current-plan {
    background: #f5f5f5 !important;
    border: 2px solid #e0e0e0 !important;
}

.rescraping-upgrade-required-plan {
    background: linear-gradient(135deg, #f0e7ff 0%, #e7d4ff 100%) !important;
    border: 2px solid #d4b3ff !important;
}

.rescraping-upgrade-plan-label {
    font-size: 0.75rem !important;
    font-weight: 600 !important;
    text-transform: uppercase !important;
    color: #888 !important;
    letter-spacing: 0.5px !important;
}

.rescraping-upgrade-plan-name {
    font-size: 1.1rem !important;
    font-weight: 700 !important;
    color: #1a1a1a !important;
    text-align: center !important;
    word-wrap: break-word !important;
    max-width: 100% !important;
}

.rescraping-upgrade-arrow-icon {
    font-size: 1.5rem !important;
    color: #5616ea !important;
    font-weight: bold !important;
    flex-shrink: 0 !important;
}

.rescraping-upgrade-button {
    background: linear-gradient(135deg, #5616ea 0%, #7c3aff 100%) !important;
    color: #ffffff !important;
    padding: 12px 32px !important;
    border: none !important;
    border-radius: 8px !important;
    font-weight: 600 !important;
    font-size: 1rem !important;
    cursor: pointer !important;
    transition: all 0.3s ease !important;
    box-shadow: 0 4px 12px rgba(94, 27, 255, 0.3) !important;
    width: 100% !important;
    max-width: 280px !important;
}

.rescraping-upgrade-button:hover {
    background: linear-gradient(135deg, #4a14d6 0%, #6328e6 100%) !important;
    transform: translateY(-2px) !important;
    box-shadow: 0 6px 16px rgba(94, 27, 255, 0.4) !important;
}

.rescraping-upgrade-button:active {
    transform: translateY(0) !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/rescrapingSettingsModal.css"],"names":[],"mappings":"AAAA;8BAC8B;AAC9B;IACI,kBAAkB;IAClB,QAAQ;IACR,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA,eAAe;AACf;IACI,mBAAmB;IACnB,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA,eAAe;AACf;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;;gEAEgE;AAChE;;;IAGI,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,eAAe;AACf;IACI,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA,WAAW;AACX;IACI,aAAa;IACb,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,2BAA2B;IAC3B,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,UAAU;IACV,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA,mBAAmB;AACnB;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA,YAAY;AACZ;IACI,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,yCAAyC;AAC7C;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,uBAAuB;AACvB;IACI,mBAAmB;IACnB,WAAW;IACX,2DAA2D;IAC3D,oCAAoC;AACxC;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA,mBAAmB;AACnB;IACI,mBAAmB;IACnB,cAAc;IACd,2DAA2D;AAC/D;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;IACvB,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA,oCAAoC;AACpC;IACI,6BAA6B;IAC7B,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;IAC9B,wEAAwE;IACxE,8BAA8B;IAC9B,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,4BAA4B;IAC5B,2BAA2B;IAC3B,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;IAC1B,sBAAsB;IACtB,2BAA2B;IAC3B,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,oBAAoB;IACpB,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;IACxB,iCAAiC;IACjC,8BAA8B;IAC9B,mBAAmB;IACnB,6BAA6B;IAC7B,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,wEAAwE;IACxE,oCAAoC;AACxC;;AAEA;IACI,6BAA6B;IAC7B,2BAA2B;IAC3B,oCAAoC;IACpC,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI,4BAA4B;IAC5B,2BAA2B;IAC3B,yBAAyB;IACzB,6BAA6B;IAC7B,gCAAgC;IAChC,0BAA0B;AAC9B;;AAEA;IACI,4BAA4B;IAC5B,yBAAyB;IACzB,4BAA4B;IAC5B,yBAAyB;AAC7B;;AAEA;IACI,wEAAwE;IACxE,yBAAyB;IACzB,6BAA6B;IAC7B,uBAAuB;IACvB,6BAA6B;IAC7B,2BAA2B;IAC3B,0BAA0B;IAC1B,0BAA0B;IAC1B,oCAAoC;IACpC,wDAAwD;IACxD,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,wEAAwE;IACxE,sCAAsC;IACtC,wDAAwD;AAC5D;;AAEA;IACI,mCAAmC;AACvC","sourcesContent":["/* Overlay takes the full viewport but lets Modal's internal\r\ntransform keep the centering */\r\n.rs-modal-overlay {\r\n    position: absolute;\r\n    inset: 0;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n/* Modal card */\r\n.rs-modal {\r\n    background: #ffffff;\r\n    border-radius: 12px;\r\n    width: 90%;\r\n    max-width: 500px;\r\n    max-height: 80vh;\r\n    padding: 24px;\r\n    overflow: hidden;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n/* Typography */\r\n.rs-title {\r\n    margin: 0 0 8px 0;\r\n    font-size: 1.4rem;\r\n    font-weight: 600;\r\n    color: #1b1b1b;\r\n}\r\n\r\n.rs-label {\r\n    font-weight: 500;\r\n    margin-right: 8px;\r\n}\r\n\r\n.rs-connector-sync-intro {\r\n    margin: 6px 0 4px 0;\r\n    font-size: 0.9rem;\r\n    color: #666;\r\n    line-height: 1.45;\r\n}\r\n\r\n.rs-label-new-links {\r\n    margin-bottom: 10px;\r\n    font-weight: 500;\r\n    margin-right: 8px;\r\n}\r\n\r\n.rs-label-links-selection {\r\n    margin-top: 10px;\r\n    font-weight: 500;\r\n    margin-right: 8px;\r\n}\r\n\r\n/* Info icon next to a label: give it breathing room from the colon and lift\r\n   it to the text's optical centre — the shared tooltip wrapper (vertical-align:\r\n   middle) sits a touch low beside the 500-weight labels here. */\r\n.rs-label .info-tooltip-wrapper,\r\n.rs-label-new-links .info-tooltip-wrapper,\r\n.rs-label-links-selection .info-tooltip-wrapper {\r\n    margin-left: 6px;\r\n    position: relative;\r\n    top: -1px;\r\n}\r\n\r\n.rs-section {\r\n    margin-top: 16px;\r\n}\r\n\r\n.rs-radio-group {\r\n    margin-top: 8px;\r\n    margin-left: -11px;\r\n}\r\n\r\n.rs-radio-label {\r\n    display: flex;\r\n    align-items: center;\r\n    margin-right: 16px;\r\n    font-size: 0.95rem;\r\n}\r\n\r\n/* Switch row */\r\n.rs-switch-row {\r\n    display: flex;\r\n    /* align-items: center; */\r\n    flex-direction: column;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.rs-switch-text {\r\n    font-size: 0.95rem;\r\n}\r\n\r\n.rs-section-input-parent {\r\n    display: flex;\r\n}\r\n\r\n/* Search */\r\n.rs-search-wrapper {\r\n    display: flex;\r\n    position: relative;\r\n    width: 100%;\r\n}\r\n\r\n.rs-search-input {\r\n    width: 100%;\r\n    padding: 7px 32px 7px 8px;\r\n    border: 1px solid #d0d0d0;\r\n    border-radius: 6px;\r\n    font-size: 0.85rem;\r\n    transition: border 0.2s;\r\n    box-sizing: border-box;\r\n    padding-left: 34px;\r\n}\r\n\r\n.new-links-text-toggle {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    margin-left: -11px;\r\n}\r\n\r\n.rs-search-icon {\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 12px;\r\n    transform: translateY(-50%);\r\n    color: #aaa;\r\n    font-size: 0.85rem;\r\n}\r\n\r\n.rs-search-input:focus {\r\n    outline: none;\r\n    border-color: #5616ea;\r\n}\r\n\r\n.rs-clear-button {\r\n    position: absolute;\r\n    top: 50%;\r\n    right: 8px;\r\n    transform: translateY(-50%);\r\n    background: none;\r\n    border: none;\r\n    font-size: 1.6rem;\r\n    color: #868686;\r\n    cursor: pointer;\r\n    padding: 0;\r\n    line-height: 1;\r\n    transition: color 0.2s ease;\r\n}\r\n\r\n.rs-clear-button:hover {\r\n    color: #5616ea;\r\n}\r\n\r\n/* Link checklist */\r\n.rs-link-box {\r\n    border: 1px solid #d0d0d0;\r\n    border-radius: 6px;\r\n    margin-top: 10px;\r\n    max-height: 300px;\r\n    overflow-y: auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 6px;\r\n    padding-top: 5px;\r\n}\r\n\r\n.rs-checkbox-row {\r\n    display: flex;\r\n    align-items: center;\r\n    font-size: 0.9rem;\r\n}\r\n\r\n.rs-checkbox-header {\r\n    display: flex;\r\n    align-items: center;\r\n    font-size: 0.9rem;\r\n    font-weight: 600;\r\n    border-bottom: 1px solid rgb(222, 222, 222);\r\n    padding-bottom: 6px;\r\n}\r\n\r\n.rs-no-links {\r\n    margin-top: 16px;\r\n    padding: 10px;\r\n    background-color: #f9f9f9;\r\n    border: 1px dashed #bbb;\r\n    border-radius: 8px;\r\n    text-align: center;\r\n    font-size: 14px;\r\n    color: #666;\r\n}\r\n\r\n.rs-warning-box {\r\n    margin-top: 8px;\r\n    padding: 10px 12px;\r\n    background-color: #fff8e6;\r\n    border: 1px solid #ffcc00;\r\n    border-radius: 8px;\r\n    font-size: 0.85rem;\r\n    color: #856404;\r\n    line-height: 1.4;\r\n}\r\n\r\n/* Buttons */\r\n.rs-button-row {\r\n    margin-top: 24px;\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    gap: 12px;\r\n}\r\n\r\n.rs-btn {\r\n    padding: 8px 18px;\r\n    border: none;\r\n    border-radius: 6px;\r\n    font-weight: 600;\r\n    font-size: 0.95rem;\r\n    cursor: pointer;\r\n    transition: background 0.2s, opacity 0.2s;\r\n}\r\n\r\n.rs-btn:disabled {\r\n    opacity: 0.5;\r\n    cursor: not-allowed;\r\n}\r\n\r\n/* Secondary (cancel) */\r\n.rs-btn--secondary {\r\n    background: #f4f4f4;\r\n    color: #333;\r\n    transition: background-color 0.3s ease, transform 0.3s ease;\r\n    border: 1px solid rgb(215, 215, 215);\r\n}\r\n\r\n.rs-btn--secondary:hover {\r\n    background: #e1e1e1;\r\n    transform: translateY(-1px);\r\n}\r\n\r\n/* Primary (save) */\r\n.rs-btn--primary {\r\n    background: #5616ea;\r\n    color: #ffffff;\r\n    transition: background-color 0.3s ease, transform 0.3s ease;\r\n}\r\n\r\n.rs-btn--primary:hover {\r\n    background-color: #4a14d6;\r\n    transform: translateY(-1px);\r\n}\r\n\r\n.row-checkbox {\r\n    padding: 5px !important;\r\n    padding-bottom: 2px !important;\r\n    padding-top: 2px !important;\r\n}\r\n\r\n/* Rescraping Upgrade Modal Styles */\r\n.rescraping-upgrade-modal-content {\r\n    text-align: center !important;\r\n    padding: 10px !important;\r\n}\r\n\r\n.rescraping-upgrade-modal-icon {\r\n    width: 64px !important;\r\n    height: 64px !important;\r\n    margin: 0 auto 20px !important;\r\n    background: linear-gradient(135deg, #5616ea 0%, #7c3aff 100%) !important;\r\n    border-radius: 16px !important;\r\n    display: flex !important;\r\n    align-items: center !important;\r\n    justify-content: center !important;\r\n    color: white !important;\r\n}\r\n\r\n.rescraping-upgrade-modal-icon svg {\r\n    width: 32px !important;\r\n    height: 32px !important;\r\n}\r\n\r\n.rescraping-upgrade-modal-title {\r\n    font-size: 1.5rem !important;\r\n    font-weight: 700 !important;\r\n    color: #1a1a1a !important;\r\n    margin: 0 0 12px 0 !important;\r\n}\r\n\r\n.rescraping-upgrade-modal-description {\r\n    font-size: 1rem !important;\r\n    color: #666 !important;\r\n    line-height: 1.5 !important;\r\n    margin: 0 0 28px 0 !important;\r\n    padding: 0 10px !important;\r\n}\r\n\r\n.rescraping-upgrade-plan-info {\r\n    display: flex !important;\r\n    align-items: center !important;\r\n    justify-content: center !important;\r\n    gap: 16px !important;\r\n    margin-bottom: 28px !important;\r\n    flex-wrap: wrap !important;\r\n}\r\n\r\n.rescraping-upgrade-plan-badge {\r\n    display: flex !important;\r\n    flex-direction: column !important;\r\n    align-items: center !important;\r\n    gap: 6px !important;\r\n    padding: 14px 24px !important;\r\n    border-radius: 10px !important;\r\n    min-width: 120px !important;\r\n}\r\n\r\n.rescraping-upgrade-current-plan {\r\n    background: #f5f5f5 !important;\r\n    border: 2px solid #e0e0e0 !important;\r\n}\r\n\r\n.rescraping-upgrade-required-plan {\r\n    background: linear-gradient(135deg, #f0e7ff 0%, #e7d4ff 100%) !important;\r\n    border: 2px solid #d4b3ff !important;\r\n}\r\n\r\n.rescraping-upgrade-plan-label {\r\n    font-size: 0.75rem !important;\r\n    font-weight: 600 !important;\r\n    text-transform: uppercase !important;\r\n    color: #888 !important;\r\n    letter-spacing: 0.5px !important;\r\n}\r\n\r\n.rescraping-upgrade-plan-name {\r\n    font-size: 1.1rem !important;\r\n    font-weight: 700 !important;\r\n    color: #1a1a1a !important;\r\n    text-align: center !important;\r\n    word-wrap: break-word !important;\r\n    max-width: 100% !important;\r\n}\r\n\r\n.rescraping-upgrade-arrow-icon {\r\n    font-size: 1.5rem !important;\r\n    color: #5616ea !important;\r\n    font-weight: bold !important;\r\n    flex-shrink: 0 !important;\r\n}\r\n\r\n.rescraping-upgrade-button {\r\n    background: linear-gradient(135deg, #5616ea 0%, #7c3aff 100%) !important;\r\n    color: #ffffff !important;\r\n    padding: 12px 32px !important;\r\n    border: none !important;\r\n    border-radius: 8px !important;\r\n    font-weight: 600 !important;\r\n    font-size: 1rem !important;\r\n    cursor: pointer !important;\r\n    transition: all 0.3s ease !important;\r\n    box-shadow: 0 4px 12px rgba(94, 27, 255, 0.3) !important;\r\n    width: 100% !important;\r\n    max-width: 280px !important;\r\n}\r\n\r\n.rescraping-upgrade-button:hover {\r\n    background: linear-gradient(135deg, #4a14d6 0%, #6328e6 100%) !important;\r\n    transform: translateY(-2px) !important;\r\n    box-shadow: 0 6px 16px rgba(94, 27, 255, 0.4) !important;\r\n}\r\n\r\n.rescraping-upgrade-button:active {\r\n    transform: translateY(0) !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
